var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98475 2.8784C7.53142 2.78774 6.91915 2.72 6.53409 2.72C5.49142 2.72 5.42369 3.17333 5.42369 3.89867V5.18987H8.03009L7.80289 7.86453H5.42369V16H2.16024V7.86453H0.48291V5.18987H2.16024V3.53547C2.16024 1.26933 3.2253 0 5.89943 0C6.82849 0 7.50849 0.136001 8.39222 0.317334L7.98475 2.8784Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5abb99aa012e7f49efa7bbeb1cea0266.svg";
export { ForwardRef as ReactComponent };